import { SAVE_URI_STATE } from '../redux-action-types'

export default (state = {}, action) => {
  switch (action.type) {
    case SAVE_URI_STATE:
      return {
        ...state,
        savedUriState: action.state
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/auth-reducer.js